import { render } from "./ManualPaasForm.vue?vue&type=template&id=db966d98&scoped=true"
import script from "./ManualPaasForm.vue?vue&type=script&lang=js"
export * from "./ManualPaasForm.vue?vue&type=script&lang=js"

import "./ManualPaasForm.vue?vue&type=style&index=0&id=db966d98&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db966d98"]])

export default __exports__